export enum ChannelTypes {
    email ='email_channel_type',
    mobile = 'mobile_channel_type',
}